import React from "react";
import { Box, Paper } from "@mui/material";
import Carousel from "react-material-ui-carousel";

const classes = {
  arkcarousel: {
    display: "grid",
    alignItems: "center",
  },
  slide: {
    textAlign: "center",
    boxShadow: "none !important",
    backgroundColor: "transparent !important",
  },
  cardImage: {
    width: "100%",
    overflow: "hidden",
    lineHeight: 0,
    backgroundColor: "#F3F3F3",
  },
  dot: {
    color: "rgba(24, 50, 66, 1) !important",
    zIndex: "1000 !important",
    position: "relative",
  },
  inactiveDot: {
    color: "rgba(0, 0, 0, 0.32) !important",
    zIndex: "1000 !important",
    position: "relative",
  },
};

const Image = ({ images, showIndicators = true, onChange }) => {
  if (!images?.length) {
    return null;
  }

  if (images.length === 1) {
    return (
      <Box bgcolor={"#F3F3F3"}>
        <Box sx={classes.cardImage}>
          <img
            style={{
              display: "block",
              height: "auto",
              width: "100%",
            }}
            src={images[0]?.location}
            alt="Slide"
          />
        </Box>
      </Box>
    );
  }

  return (
    <Box bgcolor={"#F3F3F3"}>
      <Box sx={classes.arkcarousel}>
        <Carousel
          autoPlay={false}
          interval={null}
          swipe={false}
          animation="fade"
          onChange={onChange}
          indicators={showIndicators}
          activeIndicatorIconButtonProps={{ sx: classes.dot }}
          indicatorIconButtonProps={{
            sx: classes.inactiveDot,
          }}
          // navButtonsAlwaysVisible={images?.length>1}
          navButtonsWrapperProps={{
            style: images?.length>1 ? {} : { display: "none" },
          }}
        >
          {images.map((slide, index) => (
            <Paper key={index+"Imgjsx"} sx={classes.slide}>
              <Box sx={classes.cardImage}>
                <img
                  style={{
                    display: "block",
                    height: "auto",
                    width: "100%",
                  }}
                  src={slide?.location}
                  alt="Slide"
                />
              </Box>
             
            </Paper>
          ))}
        </Carousel>
      </Box>
    </Box>
  );
};

export default Image;
